// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/pharmacy-label/pharmacy-label.less
// module id = 3734
// module chunks = 0